export default __webpack_public_path__ + "static/media/Boots of the Black Warden.c67de903.jpg";